import React from 'react';

export default function Contact() {
  return (
    <section className="max-w-4xl mx-auto py-12 px-6">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Contact Me</h1>
      <div className="prose prose-lg text-gray-600 space-y-4">
        <p>Feel free to reach out for collaborations or opportunities!</p>
        <p>📧 Email: brajthetdh@gmail.com</p>
        <p>💼 LinkedIn: https://www.linkedin.com/in/braj-bhushan-kumar-67a0b4a2/</p>
        <p>🐙 GitHub: github.com/brajthetdh1</p>
        <p>📱 Phone: +91-6201817502</p>
      </div>
    </section>
  );
}